/* REACT */
import React, { useState, useEffect } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import moment from 'moment'
import 'moment/locale/nl'

/* COMPONENTS */

/* STORE */

/* STYLES */
import {
  ItemImageWrapper,
  ItemImage,
  Title,
  TitleWrapper,
  GridItemWrapper,
  EventTypeWrapper,
  EventTypeOnImage,
  EventDetailsWrapper,
  EventMainDetailsWrapper,
  EventSecondaryDetails,
  EventSecondaryDetailsItemWrapper,
  EventSecondaryDetailsWrapper,
  GridItemDetailsWrapper,
  Location,
  Keywords,
} from './style'

/* UTILS/CONSTANTS*/
import { CLOUDFRONT_BASE_URL } from '../../../../utils/constants'
import { Analytics } from '../../../../utils'
import { logAction } from '../../../../utils/actionLogger'

/*ASSETS*/
const NoImage = `${CLOUDFRONT_BASE_URL}/assets/images/NoImage.png`
const PinImage = `${CLOUDFRONT_BASE_URL}/assets/icons/Pin.svg`

const EventItem = ({
  index,
  isLessThanLaptop,
  item,
  language,
  key,
  itemsPerRow,
  organizationDetails,
}) => {
  // SET MOMENT LOCALE TO CURRENT LANGUAGE
  moment.locale(language)

  const { name, images, locations, event_type, keywords, date, timings } = item
  const [keywordsText, setKeywordsText] = useState(null)

  const itemImage = images?.length ? images[0]?.url : NoImage

  const mouseDownCoords = e => {
    window.checkForDrag = e.clientX
  }

  useEffect(() => {
    if (keywords?.length) {
      let keywordsString = ''
      for (let keyword of keywords) {
        if (keywordsString.length > 0) keywordsString += ' | '
        keywordsString += `${keyword}`
      }

      setKeywordsText(keywordsString)
    }
  }, [key])

  if (!organizationDetails?.slug) {
    return null
  }

  return (
    <GridItemWrapper
      target={
        organizationDetails?.openNewTabOnClickthroughGrid ? '_blank' : '_self'
      }
      href={item.url}
      onClick={() => {
        logAction({
          name: 'url_click_grid',
          url: item.url,
          linkLabel: name,
        })
      }}
      itemsPerRow={itemsPerRow}
    >
      <GridItemDetailsWrapper>
        <ItemImageWrapper onMouseDown={e => mouseDownCoords(e)}>
          <ItemImage index={index} backgroundImage={itemImage}>
            {event_type ? (
              <EventTypeWrapper>
                <EventTypeOnImage>{event_type}</EventTypeOnImage>
              </EventTypeWrapper>
            ) : null}
          </ItemImage>
        </ItemImageWrapper>

        <EventDetailsWrapper>
          <EventMainDetailsWrapper>
            {date ? (
              <EventSecondaryDetailsWrapper>
                <EventSecondaryDetailsItemWrapper>
                  {' '}
                  <EventSecondaryDetails>
                    {date}
                    {timings ? ` - ${timings}` : ''}
                  </EventSecondaryDetails>
                </EventSecondaryDetailsItemWrapper>
              </EventSecondaryDetailsWrapper>
            ) : null}

            {name ? (
              <EventSecondaryDetailsWrapper>
                {name ? (
                  <TitleWrapper>
                    <Title>{name}</Title>
                  </TitleWrapper>
                ) : null}
              </EventSecondaryDetailsWrapper>
            ) : null}

            {locations?.length && locations[0] ? (
              <EventSecondaryDetailsWrapper>
                <TitleWrapper>
                  {locations?.length && locations[0] ? (
                    <Location>{locations[0]}</Location>
                  ) : null}
                </TitleWrapper>
              </EventSecondaryDetailsWrapper>
            ) : null}
          </EventMainDetailsWrapper>
        </EventDetailsWrapper>
      </GridItemDetailsWrapper>
    </GridItemWrapper>
  )
}

const mapStateToProps = state => ({
  organizationDetails: state?.maya?.organizationDetails,
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(EventItem)
